import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Nav, Navbar, Button } from 'react-bootstrap'
import './_navbars.scss'
import NetworkStatus from './NetworkStatus';
import moment from 'moment'
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import "hacktimer";

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";


let hidden = null;
let visibilityChange = null;
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support 
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
}
const AUTO_SUBMIT_TIME = gql` 
query($student_user_exam_id: Int!,$exam_paper_id:Int!) {
    getAutoSubmitTime(student_user_exam_id: $student_user_exam_id,exam_paper_id:$exam_paper_id){
        auto_submit_time
        is_proctoring_enabled
        proctoring_attempt_limit {
            proctoring_type_id
            max_allowed
        }
    }
}
`;
class MockExamNavbar extends Component {

    constructor(props) {
        super(props);

        //console.log("eeeeeeeeeeeee", this.props.examInstructions)
        let totalExamCount = "";
        let splitHeadingName = this.props.getData.type.split("(");
        let local = localStorage.getItem("resumeExam");

        if (this.props.examInstructions.exam_pattern_id > 0) {
            if ((local == true && !!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length > 0) || (!!props.resumeExam && props.resumeExam && !!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length > 0)) {
                if (parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time) == 0) {
                    props.totTimeFunction();
                } else {
                    totalExamCount = parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time);
                }
            } else if (!!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length == 0 && !!props.getAutoSaveExam && props.getAutoSaveExam.length > 0) {
                totalExamCount = parseInt(props.getAutoSaveExam[0].examtimer);
            } else if (!!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length > 0 && props.getData.type != 'Custom Exam') {
                if (parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time) == 0) {
                    props.totTimeFunction();
                } else {
                    totalExamCount = parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time);
                }
            } else {
                totalExamCount = parseInt(props.examInstructions.exam_duration_min * 60);
            }
        } else {
            if ((local == true && !!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length > 0) || (!!props.resumeExam && props.resumeExam && !!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length > 0)) {
                if (parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time) == 0) {
                    props.totTimeFunction();
                } else {
                    totalExamCount = parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time);
                }
            } else if (!!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length == 0 && !!props.getAutoSaveExam && props.getAutoSaveExam.length > 0) {
                totalExamCount = parseInt(props.getAutoSaveExam[0].examtimer);
            } else if (!!props.getAutoSubmitTime.getAutoSubmitTime && props.getAutoSubmitTime.getAutoSubmitTime.length > 0 && props.getData.type != 'Custom Exam') {
                if (parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time) == 0) {
                    props.totTimeFunction();
                } else {
                    totalExamCount = parseInt(props.getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time);
                }
            }
            else if (props.getPracticeQuestions && props.getPracticeQuestions.length > 0 && props.getPracticeQuestions[0].mains_2021 == "1") {
                totalExamCount = parseInt(props.exam_time) * parseInt(props.getPracticeQuestions.length - 15);
            }
            else if (props.getPracticeQuestions && props.getPracticeQuestions.length > 0 && props.getPracticeQuestions[0].mains_2021 == "0" && this.props.examInstructions != undefined && this.props.examInstructions.exam_model_id == "2") {
                totalExamCount = parseInt(props.exam_time) * parseInt(props.getPracticeQuestions.length - 20);
            }
            else if (props.examInstructions != undefined && (props.examInstructions.is_partexam == 1 || props.examInstructions.exam_model_type_id == 4)) {
                totalExamCount = parseInt(props.examInstructions.time_duration * 60);
            }
            else if (props.getPracticeQuestions && props.getPracticeQuestions.length > 0) {
                totalExamCount = parseInt(props.exam_time) * parseInt(props.getPracticeQuestions.length);
            }
            else {
                totalExamCount = 0;
            }
        }



        this.state = {
            timerStatus: false,
            totalExamCount: totalExamCount,
            oldCount: totalExamCount,
        }
        this.handleChangeinTime = this.handleChangeinTime.bind(this);
    }


    timeFunction = () => {
        //console.log("tottime", this.state.timerStatus);
        if (this.state.timerStatus == false) {
            let totalExamCount = parseInt(this.state.totalExamCount) - 1;
            //console.log("tottimestatus", totalExamCount);
            if (totalExamCount == 0) {
                this.setState({
                    timerStatus: true,
                    totalExamCount: totalExamCount
                });
                this.props.totTimeFunction();
            }
            else {
                this.setState({
                    totalExamCount: totalExamCount
                });
                if (this.props.totalExamCount) {
                    this.props.totalExamCount(totalExamCount)
                }
            }
        }
    }
    timeFunctionNew = () => {
        //console.log("tottime", this.state.timerStatus);
        if (this.state.timerStatus == false) {
            let totalExamCount = parseInt(this.state.totalExamCount) - 1;
            //console.log("tottimestatus", totalExamCount);
            if (totalExamCount == 0) {
                this.setState({
                    timerStatus: true,
                    totalExamCount: totalExamCount
                });
                this.props.totTimeFunction();
            }
            else {
                this.setState({
                    totalExamCount: totalExamCount
                });
                if (this.props.totalExamCount) {
                    this.props.totalExamCount(totalExamCount)
                }
            }
        }
    }

    componentDidMount = () => {
        if (this.state.totalExamCount == 0) {
            this.props.ParenthandleFormSubmit();
        }
        this.timer = setInterval(() => {
            this.timeFunction();
        }, 1000);
        //document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
    }

    handleVisibilityChange = () => {
        if (document[hidden]) {
            this.timer1 = setInterval(() => {
                this.timeFunctionNew();
            }, 1000);
        } else {
            clearInterval(this.timer1);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.getAutoSubmitTime !== prevProps.getAutoSubmitTime) {
            this.handleChangeinTime(this.props.getAutoSubmitTime);
        }
    }

    componentWillUnmount() {
        document.removeEventListener(visibilityChange, this.handleVisibilityChange);
        clearInterval(this.timer);
        clearInterval(this.timer1);
    }

    minutesTimer = (data) => {
        var date = new Date(data * 1000);
        var hh = date.getUTCHours();
        var mm = date.getUTCMinutes();
        var ss = date.getSeconds();
        if (hh < 10) { hh = "0" + hh; }
        if (mm < 10) { mm = "0" + mm; }
        if (ss < 10) { ss = "0" + ss; }
        var t = hh + ":" + mm + ":" + ss;

        return t;
    }
    handleChangeinTime = (getAutoSubmitTime) => {
        if (getAutoSubmitTime.getAutoSubmitTime && getAutoSubmitTime.getAutoSubmitTime.length > 0) {
            let totalExamCount = parseInt(getAutoSubmitTime.getAutoSubmitTime[0].auto_submit_time);
            if (this.state.oldCount == this.state.totalExamCount && totalExamCount != this.state.totalExamCount && this.props.getData.type != 'Custom Exam') {
                this.setState({
                    totalExamCount: totalExamCount,
                });
            }
        }
    }


    render() {

        const isMobile = window.innerWidth < 768;
        const getStudentTestSeriesNewNTAPattern = this.props.getStudentTestSeriesNewNTAPattern;
        const getAutoSubmitTime = this.props.getAutoSubmitTime;
        const loading6 = getAutoSubmitTime.loading;
        const error6 = getAutoSubmitTime.error;

        return (
            <Navbar bg="white" className="examtop-header header-top shadow-sm" expand="lg">
                <Container>

                    {/* ================= DESKTOP HEADER ================= */}

                    <Navbar.Collapse className="d-none d-lg-flex">

                        {/* TIMER */}
                        <Nav className="mr-auto">
                            <div className="timecounter" style={{ display: "flex", alignItems: "center" }}>
                                <i className="fas fa-clock mr-2"></i>
                                Time Left : {this.minutesTimer(this.state.totalExamCount)}
                            </div>
                        </Nav>

                        {/* TITLE */}
                        <Nav className="mx-auto">
                            <h6 className="title text-muted">
                                {this.props.getData.type}
                            </h6>
                        </Nav>

                        {/* RIGHT CONTROLS */}
                        <Nav className="ml-auto" style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                            <NetworkStatus />

                            {/* FONT SIZE */}
                            <span
                                className={
                                    this.props.stateData.fontSizeIncreaseA == "active"
                                        ? "round-circle-FS active font-AA"
                                        : "round-circle-FS font-AA"
                                }
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                }}
                                onClick={(e) => this.props.pfontSizeIncrease(e, "A")}
                            >
                                A
                            </span>

                            <span
                                className={
                                    this.props.stateData.fontSizeIncreaseAA == "active"
                                        ? "round-circle-FS active font-AAA"
                                        : "round-circle-FS font-AAA"
                                }
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                }}
                                onClick={(e) => this.props.pfontSizeIncrease(e, "AA")}
                            >
                                A<sup>+</sup>
                            </span>

                            {this.props.getPracticeQuestions != "" && (

                                <React.Fragment>

                                    <Button
                                        variant="outline-info"
                                        style={{ width: 40, height: 40, borderRadius: "50%" }}
                                        onClick={this.props.handleQuestions}
                                    >
                                        Q
                                    </Button>

                                    <Button
                                        variant="outline-info"
                                        style={{ width: 50, borderRadius: 25 }}
                                        onClick={this.props.handleInstructions}
                                    >
                                        <i className="fas fa-question-circle"></i>
                                    </Button>

                                    <Button
                                        variant="outline-success"
                                        style={{ width: 180, borderRadius: 25, fontWeight: "bold" }}
                                        onClick={this.props.ParenthandleFormSubmit}
                                    >
                                        Submit Exam
                                    </Button>

                                </React.Fragment>

                            )}

                        </Nav>

                    </Navbar.Collapse>



                    {/* ================= MOBILE HEADER ================= */}

                    <div className="d-block d-lg-none" style={{ width: "100%" }}>

                        {/* TITLE */}
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <h6 className="title text-muted mb-0">
                                {this.props.getData.type}
                            </h6>
                            <NetworkStatus />
                        </div>

                        {/* TIMER + SUBMIT */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0px 10px",
                                marginTop: "6px"
                            }}
                        >

                            <div
                                className="timecounter"
                                style={{ display: "flex", alignItems: "center", fontSize: "14px" }}
                            >
                                <i className="fas fa-clock mr-2"></i>
                                Time Left : {this.minutesTimer(this.state.totalExamCount)}
                            </div>

                            {this.props.getPracticeQuestions != "" && (

                                <Button
                                    variant="outline-success"
                                    style={{
                                        width: "140px",
                                        borderRadius: "25px",
                                        fontWeight: "bold"
                                    }}
                                    onClick={this.props.ParenthandleFormSubmit}
                                >
                                    Submit Exam
                                </Button>

                            )}

                        </div>


                        {/* CONTROLS */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "15px",
                                padding: "8px 10px"
                            }}
                        >

                            {/* FONT SIZE */}

                            <span
                                className={
                                    this.props.stateData.fontSizeIncreaseA == "active"
                                        ? "round-circle-FS active font-AA"
                                        : "round-circle-FS font-AA"
                                }
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                }}
                                onClick={(e) => this.props.pfontSizeIncrease(e, "A")}
                            >
                                A
                            </span>

                            <span
                                className={
                                    this.props.stateData.fontSizeIncreaseAA == "active"
                                        ? "round-circle-FS active font-AAA"
                                        : "round-circle-FS font-AAA"
                                }
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                }}
                                onClick={(e) => this.props.pfontSizeIncrease(e, "AA")}
                            >
                                A<sup>+</sup>
                            </span>


                            {/* QUESTION BUTTON */}

                            <Button
                                variant="outline-info"
                                style={{ width: 36, height: 36, borderRadius: "50%" }}
                                onClick={this.props.handleQuestions}
                            >
                                Q
                            </Button>


                            {/* INSTRUCTION BUTTON */}

                            <Button
                                variant="outline-info"
                                style={{ width: 36, height: 36, borderRadius: "50%" }}
                                onClick={this.props.handleInstructions}
                            >
                                <i className="fas fa-question-circle"></i>
                            </Button>


                            {/* MOBILE MENU */}

                            <Button
                                variant="light"
                                style={{ padding: "4px 8px" }}
                                onClick={() => this.props.onClick()}
                            >
                                <i className="fal fa-bars"></i>
                            </Button>

                        </div>

                    </div>


                </Container>
            </Navbar>
        )
    }
}

export default withRouter(
    compose(graphql(AUTO_SUBMIT_TIME, {
        options: props => ({
            variables: {
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                exam_paper_id: parseInt(localStorage.getItem('exam_paper_id'))
            }
            ,
            // Exam-paper configuration, fixed per exam_paper_id; shared cache entry.
            fetchPolicy: "cache-first"
        }),
        name: "getAutoSubmitTime"
    }))(MockExamNavbar));